import {createFileRoute} from '@tanstack/react-router';
import {SavingsAccountWithdrawalCallbackPage} from 'features/deposit/withdrawal/SavingsAccountWithdrawalCallbackPage';

export const Route = createFileRoute('/_protected/withdrawal/callback')({
  component: SavingsAccountWithdrawalCallbackPage,
  validateSearch: (search) => {
    return {
      accountId: search.accountId as string | undefined,
      status: search.status as string | undefined,
    };
  },
});
